import {rule} from '@/util/validateRules'
import {getStore} from '@/util/store'
import {type} from 'jquery'

//投保工种
export const planEmployeeOption = {
	border: true,
	stripe: true,
	editBtn: false,
	menuWidth: 120,
	delBtn: false,
	header: false,
	align: 'center',
	headerAlign: 'center',
	column: [
		{
			label: '雇员类别',
			prop: 'professionId',
			rules: [
				{
					required: true,
					message: '请选择 工种类别',
					trigger: 'blur',
				},
			],
			cell: true,
			type: 'cascader',
			dicData: [],
			props: {
				label: 'categoryName',
				value: 'id',
			},
			filterable: true,
			emitPath: false,
			showAllLevels: true,
			disabled: false,
			hide: false,
			dataType: 'string',
			expandTrigger: 'click',
			clearable: false,
		},
		{
			label: '是否涉高',
			prop: 'highKey',
			type: 'select',
			width: 180,
			cell: true,
			hide: true,
			dicData: [],
		},
		{
			label: '人数',
			prop: 'empNum',
			width: 180,
			rules: [
				{
					required: true,
					message: '请输入 人数',
					trigger: 'blur',
				},
				{
					required: true,
					validator: rule.validatorEmpNum,
					trigger: ['blur', 'change'],
				},
			],
			type: 'number',
			min: 0,
			max: 1000,
			precision: 0,
			cell: true,
			disabled: false,
		},
		{
			label: '单人保费',
			children: [],
		},
	],
}

export const planListOption = (safe) => {
	return {
		card: true,
		stripe: true,
		border: true,
		align: 'center',
		menuAlign: 'center',
		searchMenuSpan: 12,
		addBtn: false,
		delBtn: false,
		editBtn: false,
		searchLabelWidth: 100,
		searchMenuPosition: 'right',
		column: [
			{
				label: '产品名称',
				prop: 'insureType',
				type: 'select',
				dicData: getStore({name: 'insureTypes'}),
				props: {
					label: 'name',
					value: 'type',
				},
				search: true,
			},
			{
				label: '企业名称',
				prop: 'unitName',
				search: true,
				formatter: ({unitName = ''}) => {
					return unitName ? unitName : '--'
				},
			},
			// {
			//   label: '下载地址',
			//   prop: 'fileUrl',
			//   slot: true
			// },

			// {
			//   label: '操作人',
			//   prop: 'countRatePercent',
			//   search: true
			// },
			{
				label: '创建时间',
				prop: 'createTime',
			},
			{
				label: '更新时间',
				prop: 'updateTime',
			},
		],
	}
}

const planOtherDataList = [
	{name: '（新）太保泛高空雇主险光伏全国普通版', id: '543'},
	{name: '（新）太保泛高空雇主险光伏地区普通版', id: '545'},
	{name: '（新）太保泛高空雇主险光伏全国尊贵版', id: '544'},
	{name: '（新）太保泛高空雇主险光伏地区尊贵版', id: '546'},
	{name: '（新）太保泛高空雇主险全国普通版', id: '528'},
	{name: '（新）太保泛高空雇主险地区普通版', id: '530'},
	{name: '（新）太保泛高空雇主险全国尊贵版', id: '529'},
	{name: '（新）太保泛高空雇主险地区尊贵版', id: '531'},
	{name: '（新）太保泛高空雇主险外墙全国普通版', id: '532'},
	{name: '（新）太保泛高空雇主险外墙地区普通版', id: '534'},
	{name: '（新）太保泛高空雇主险外墙全国尊贵版', id: '533'},
	{name: '（新）太保泛高空雇主险外墙地区尊贵版', id: '535'},
	{name: '（新）太保泛高空雇主险外墙全国普通版_年单特别版', id: '527'},
	{name: '（新）太保泛高空雇主险设备安装全国普通版', id: '536'},
	{name: '（新）太保泛高空雇主险设备安装地区普通版', id: '538'},
	{name: '（新）太保泛高空雇主险设备安装全国尊贵版', id: '537'},
	{name: '（新）太保泛高空雇主险设备安装地区尊贵版', id: '539'},
	{name: '（新）太保泛高空雇主险全国普通版_年单特别版', id: '526'},
	{name: '（新）太保泛高空雇主险门窗尊贵版', id: '524'},
	{name: '（新）太保泛高空雇主险门窗普通版', id: '525'},
	{name: '（新）太保泛高空雇主险钢结构普通版', id: '523'},
	{name: '（新）太保泛高空雇主险钢结构尊贵版', id: '522'},
	{name: '（新）太保泛高空雇主险豪华版', id: '540'},
	{name: '（新）太保泛高空雇主险电力通讯全国普通版', id: '547'},
	{name: '（新）太保泛高空雇主险电力通讯地区普通版', id: '549'},
	{name: '（新）太保泛高空雇主险灵工全国版', id: '541'},
	{name: '（新）太保泛高空雇主险灵工地区版', id: '542'},
	{name: '（新）美亚1-6类团意险C款', id: '506'},
	{name: '（新) 美亚1-6类团意险C款扩展自费药', id: '507'},
]

export const planNoticeListOption = (safe) => {
	return {
		card: true,
		stripe: true,
		border: true,
		align: 'center',
		menuAlign: 'center',
		addBtn: false,
		editBtn: false,
		searchMenuSpan: 18,
		searchMenuPosition: 'right',
		delBtn: false,
		column: [
			//方案ID
			{
				label: '方案ID',
				prop: 'productId',
			},
			{
				label: '方案名称',
				prop: 'productId',
				dicUrl: `/dist/distProduct/ht/listInfo`,
				dicQuery: {
					page: 1,
					size: 999999,
				},
				search: true,
				filterable: true,
				type: 'select',
				props: {
					label: 'name',
					value: 'id',
				},
				dicFormatter: function ({data}) {
					let records = data.records || []
					let rData = []
					records.forEach((c) => {
						if (c.productPlanRelationList && c.productPlanRelationList.length > 0) {
							let concatData = c.productPlanRelationList.map((o) => ({
								id: parseInt(o.planId),
								name: o.planName,
							}))

							rData = [...rData, ...concatData]
						} else {
							rData.push({id: parseInt(c.productId), name: c.title})
						}
					})
					//rData合并planOtherDataList
					rData = [...rData]

					return rData
				},
			},
			{
				label: '封面图片',
				prop: 'backgroundImg',
				dataType: 'string',
				type: 'img',
			},
			{
				label: '内容',
				prop: 'specialPromise',
				formatter: ({specialPromise}) => {
					if (!specialPromise) {
						return ''
					}
					let specialPromises = JSON.parse(specialPromise)
					let str = ''
					specialPromises.forEach((item) => {
						str += item.value + '  '
					})

					return str.length > 30 ? `${str.substring(0, 30)}...` : str
				},
			},
		],
	}
}

//计划书option
export const planAddNoticeOption = {
	emptyBtn: false,
	submitBtn: false,
	column: [
		{
			label: '方案名称',
			prop: 'productId',
			type: 'select',
			allowCreate: true,
			filterable: true,
			rules: [
				{
					required: true,
					message: '请选择方案名称',
					trigger: 'blur',
				},
			],
			dicUrl: `/dist/distProduct/ht/listInfo`,
			dicQuery: {
				page: 1,
				size: 999999,
			},
			props: {
				label: 'name',
				value: 'id',
			},
			dicFormatter: function ({data}) {
				let records = data.records || []
				let rData = []
				records.forEach((c) => {
					if (c.productPlanRelationList && c.productPlanRelationList.length > 0) {
						let concatData = c.productPlanRelationList.map((o) => ({
							id: parseInt(o.planId),
							name: o.planName,
						}))

						rData = [...rData, ...concatData]
					} else {
						rData.push({id: parseInt(c.productId), name: c.title})
					}
				})
				console.log(333, rData)
				return rData
			},
			row: true,
			disabled: false,
		},
		// {
		//     label: '方案名称',
		//     prop: 'productId',
		//     dicData: [],
		//     type: "select",
		//     props: {
		//         label: 'title',
		//         value: 'id'
		//     },
		//     rules: [{
		//         required: true,
		//         message: '请输入险种ID',
		//         trigger: 'blur'
		//     }],
		//     disabled: false
		// },
		{
			label: '封面图片',
			prop: 'backgroundImg',
			type: 'upload',
			listType: 'picture-img',
			fileSize: 1024,
			action: '/dist/distInsure/uploadFile',
			propsHttp: {
				res: 'data',
			},
			dragFile: true,
			tip: '请上传大小不超过1Mb的jpg/png文件',

			rules: [
				{
					required: true,
					message: '请上传PDF封面图片',
					trigger: 'blur',
				},
			],
			row: true,
			disabled: false,
		},
		{
			label: '内容编辑',
			prop: 'specialPromise',
			span: 24,
			formslot: true,
			rules: [
				{
					required: true,
					message: '请填写投保须知',
					trigger: 'change',
					validator: (rule, value, callback) => {
						callback()
					},
				},
			],
			disabled: false,
		},
	],
}
